import React from 'react'
import './Careers.css'
import { Link } from 'react-router-dom'

const Careers = () => {
  return (
    <div className='career'>
      <div className='resume'>
       <p className='resume1'>SUBMIT YOUR RESUME</p>
       <p>A few of the things you can expect from working here.</p>
       <div className='link'>
       <Link to='#'>hr@swajit.com</Link>
       </div>
       <div className='work'>
       <p className='location'><span>Work Location</span></p>
       </div>
      </div>
    </div>
  )
}

export default Careers
